import "../style/completeTheLook.scss";
import Title from "./common/Title";
import { useEffect, useRef, useState } from "react";
import { dataLoader } from "@unbxd-ui/unbxd-react-components";
import utils from "./common/utils";
import pageRoute from "../routes/pageRoute";
import Cropper from './common/Cropper';
import searchIcon from "../common/images/search_icon.png";
import Xarrow, { useXarrow, Xwrapper } from "react-xarrows";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { Navigation, Pagination, Scrollbar, A11y, Mousewheel } from 'swiper';

utils.addRequestConfigs(pageRoute);

export default function CompleteTheLook() {
    let imgArr = [
        [
            "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/1700944/2022/3/2/33f426d3-752f-45fa-8344-e0b16f48bfc61646215571249-HRX-by-Hrithik-Roshan-Men-Yellow-Printed-Cotton-Pure-Cotton--7.jpg",
            "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/18984180/2022/7/27/9b7566e1-6e9f-4d86-b55e-b32594ab46791658920876941-Levis-Men-Green-Brand-Logo-Printed-Pure-Cotton-T-shirt-36816-5.jpg",
            "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/1072681/2020/1/20/3fa6128e-dbb6-4b85-a54f-57231fc9d56d1579503443792-Roadster-Men-Charcoal-Melange-Printed-Round-Neck-T-shirt-364-4.jpg",
            "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/8889597/2019/4/8/8dc49bf7-181d-4d8d-80d7-e624ef85e3651554718288714-Roadster-Men-Navy-Blue--Grey-Regular-Fit-Checked-Casual-Shir-1.jpg",
            "http://assets.myntassets.com/assets/images/12858682/2020/11/12/84dec673-8507-4f33-b45a-18f5adcfdfc61605170703279-Off-Label-5471605170702129-5.jpg",
            "http://assets.myntassets.com/assets/images/17498008/2022/3/12/ced0cf4b-7ca3-4328-b03d-8df7f7daf5f51647065657821FASHORWomenMaroonEthnicMotifsPrintedGottaPattiKurtawithTrous1.jpg",
        ],
        [ "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/12645740/2020/12/9/ee3f4106-29ff-4fe3-acb2-6ee46816cb2f1607512641509-Chemistry-Women-Tshirts-8691607512639380-1.jpg",
            "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/2355195/2021/6/4/56877f02-8afd-4b1b-92a1-14ddc0a1de621622789341127-Roadster-Women-White-Solid-Round-Neck-T-shirt-37162278934061-1.jpg",
            "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/12150606/2020/8/26/8a46269d-372c-4251-a105-79090f59844f1598441510060-plusS-Women-Black-Self-Design-A-Line-Top-9211598441507789-1.jpg"
        ]
    ];

    const [ image, setImage ] = useState(imgArr[ 0 ][ 0 ]);
    const [ inputValue, setInputValue ] = useState("")
    const [ data, setData ] = useState([]);
    const [ hotSpot, setHotSpot ] = useState(0);
    const [ selectedImage, setSelectedImage ] = useState("https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/1700944/2022/3/2/33f426d3-752f-45fa-8344-e0b16f48bfc61646215571249-HRX-by-Hrithik-Roshan-Men-Yellow-Printed-Cotton-Pure-Cotton--7.jpg");
    const inputRef = useRef(null);
    const [ error, setError ] = useState("")
    const [ isLoading, setIsLoading ] = useState(false);

    const validate = (val) => {
        if (val.length === 0) {
            setError("Input cannot be empty");
            return false;
        } else if (!/(?:(?:https?|ftp):\/\/|\b(?:[a-z\d]+\.))(?:(?:[^\s()<>]+|\((?:[^\s()<>]+|(?:\([^\s()<>]+\)))?\))+(?:\((?:[^\s()<>]+|(?:\(?:[^\s()<>]+\)))?\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))?/.test(val)) {
            setError("Please enter a Valid Url");
            return false
        } else {
            setError("");
            return true;
        }
    }

    const callApi2 = () => {
        setIsLoading(true);
        const def = dataLoader.getRequestDef({
            requestId: "getCompleteLook",
            params: {
                url: image,
            },
        });

        def.done((response = {}) => {
            let { errors = [], result = [] } = response;
            setIsLoading(false);
            if (errors && errors.length) {
            }
            setData(result)
        });

        def.catch((error) => {
            setIsLoading(false);
        });
        return def;
    };

    function setUrl(e) {
        if (validate(e.target.src || inputValue)) {
            if (e.target.src) {
                setSelectedImage(e.target.src);
                setImage(e.target.src);
            } else {
                setSelectedImage(inputValue);
                setImage(inputValue);
            }
        }
    }

    useEffect(() => {
        const api = callApi2();
    }, [ image ]);

    return (
        <div className="columns highlight-info sticky-hexagon-reverse">
            <div className="column col-xl-12 col-5 highlight-content-left ">
                <div className="content-wrap">

                    {!isLoading && data.map((main = {}, index) => {
                        if (index === hotSpot) {
                            return (
                                <Xwrapper><Xarrow
                                    start={`hotspot-${hotSpot}`} //can be react ref
                                    end={`ctl-rec-img-id`} //or an id
                                    zIndex={1000}
                                    endAnchor={{ position: "left", offset: { x: 70 } }}
                                    dashness={{ strokeLen: 10, nonStrokeLen: 10, animation: -2 }}
                                    animateDrawing={true}
                                /></Xwrapper>
                            )
                        }

                    })}


                    <Title title="Complete The Look" className="title mb-2" />
                    <div className="feature-description desc col-xl-12 col-12">
                        This solution will allow the customers to find the complementary clothes and accessories that goes well with the product of their choice. The objective is to recommend visual compatible products for example which t-shirts or shoes will go well with this pant.
                    </div>
                    <div className="spin">Try Your Image</div>

                    <div className="search-container">
                        <div className="search-input-container">
                            <input ref={inputRef} type="text" value={inputValue} placeholder="Enter Image URL" className="search-input" onChange={e => setInputValue(e.target.value)} />
                            <img src={searchIcon} className="search-img" />
                        </div>
                        <button onClick={(e) => setUrl(e)} className="search-button">Preview</button>
                    </div>
                    {error && <div className="api-error entity-extraction">{error}</div>}

                    <div className="image-container">
                        <div className="best-results">
                            For best results use e-commerce apparel images
                        </div>
                        <div className="spin">Try With Sample Images</div>
                        <div className="box">
                            {imgArr.map((arrItem) => {
                                return <div className="box-items">
                                    {arrItem.map(item => {
                                        return <img
                                            className={`product-img ${selectedImage === item ? "product-img-selected" : ""}`}
                                            src={(item)}
                                            onClick={(e) => setUrl(e)}
                                        />;
                                    })}
                                </div>
                            })}
                        </div>
                    </div>
                </div>
            </div>

            <div className="column col-xl-12 col-7">
                { <div className="content-wrap">
                    <div className="ctl-rhs">
                        <div className="ctl-main-image">
                            <img id="mainImage" src={image} />
                            {!isLoading && data.map((main = {}, index) => {
                                const image = document.getElementById('mainImage');
                                const scaleX = image.naturalWidth / image.width;
                                const scaleY = image.naturalHeight / image.height;

                                const coordinates = main.box;
                                const x = coordinates[ 0 ],
                                    y = coordinates[ 1 ],
                                    width = coordinates[ 2 ] - coordinates[ 0 ],
                                    height = coordinates[ 3 ] - coordinates[ 1 ];
                                const left = (x + width / 2) / scaleX - 10;
                                const top = (y + height / 2) / scaleY - 10;
                                return <div className="hotspot" id={`hotspot-${index}`} style={{ top: top, left: left }} onClick={(e) => setHotSpot(index)}></div>
                            })}
                        </div>
                        <div id="ctl-rec-img-id">
                            {!isLoading && data.map((main = {}, index) => {
                                if (index === hotSpot) {
                                    return (
                                        <Cropper className="ctl-rec-img" url={image} coordinates={main.box} key={hotSpot} id={hotSpot} />
                                    )
                                }
                            })}
                             {isLoading && <img className="ms-loading-icon" src={"/images/blueLoader.svg"} /> }
                        </div>
                    </div>
                    {!isLoading && data.length > 0 && <div className="cropped-rec-wrapper">
                        <div className="ctl-rec-heading2">Matching recomendations for the selected product </div>
                        <Swiper
                            modules={[ Navigation, Pagination, Scrollbar, A11y, Mousewheel ]}
                            slidesPerView={"auto"}
                            centeredSlides={true}
                            spaceBetween={30}
                            pagination={{
                                clickable: true,
                            }}
                            navigation={true}
                            mousewheel={true}
                            initialSlide={2}
                        >
                            {data[ hotSpot ].ctl.map((c, i) => {
                                return <SwiperSlide>
                                    <Cropper url={c.content} coordinates={c.box} key={hotSpot + '-' + i} id={hotSpot + '-' + i} />
                                </SwiperSlide>
                            })}
                        </Swiper>
                    </div>
                    }
                     {isLoading && <img className="ms-loading-icon" src={"/images/blueLoader.svg"} /> }
                </div>}
               
            </div>
        </div>
    );
}
